module.exports = __webpack_public_path__ + "img/cs2_esp.e8677305.png";